"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./atoms.pc.css");
//# sourceMappingURL=atoms.pc.js.map